import { CancelablePromise, OpenAPI, request as __request } from '/src/api';
import { Statement } from '/src/lib/models';

export class StatementService {
  /**
   * List Loan Statements
   * @returns Statement[]
   * @throws ApiError
   */
  public static async queryStatements(query?: any): CancelablePromise<Statement[]> {
    return await __request(OpenAPI, {
      method: 'GET',
      url: '/transactions/:loanId/:statementId',
      query,
    });
  }
}
